(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.HarrodBoundaryVisuals = api;
})(function () {
  'use strict';
  var originals = {
    pleached: 'https://harrod-outdoors.myshopify.com/cdn/shop/files/228-tree-styles-pleached.png?v=7964486551005791540',
    screens: 'https://harrod-outdoors.myshopify.com/cdn/shop/files/197-hedging-styles-hedging-screen.png?v=1790159405'
  };
  function finite(value, fallback) { return typeof value === 'number' && Number.isFinite(value) ? value : fallback; }
  function n(value) { return String(Math.round(value * 1000) / 1000); }
  function escape(value) {
    return String(value == null ? '' : value).slice(0, 180).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }
  // Crop the existing artwork, rather than drawing a replacement.
  // Separate crown/trunk crops keep the lower circular outline out of the tree.
  function crop(url, sourceSize, viewBox, x, y, width, height) {
    return '<svg x="' + n(x) + '" y="' + n(y) + '" width="' + n(width) + '" height="' + n(height) + '" viewBox="' + viewBox + '" preserveAspectRatio="none" overflow="hidden"><image href="' + url + '" x="0" y="0" width="' + sourceSize + '" height="' + sourceSize + '"/></svg>';
  }
  function plant(kind, custom, x, y, scale) {
    if (kind === 'screens') {
      return crop(originals.screens, 1024, '220 136 584 782', x, y, 584 * scale, 782 * scale);
    }
    var crownWidth = custom ? 210 : 168;
    return crop(originals.pleached, 365, '102 49 168 160', x, y, crownWidth * scale, 160 * scale) +
      crop(originals.pleached, 365, '179 209 14 150', x + (crownWidth - 14) * scale / 2, y + 160 * scale, 14 * scale, 150 * scale);
  }
  function arrow(x1, x2, y) {
    return '<path d="M' + n(x1) + ' ' + n(y) + 'H' + n(x2) + 'M' + n(x1 + 4) + ' ' + n(y - 3) + 'L' + n(x1) + ' ' + n(y) + 'L' + n(x1 + 4) + ' ' + n(y + 3) + 'M' + n(x2 - 4) + ' ' + n(y - 3) + 'L' + n(x2) + ' ' + n(y) + 'L' + n(x2 - 4) + ' ' + n(y + 3) + '" fill="none" stroke="#496a2d" stroke-width="1.5"/>';
  }
  function icon(options) {
    options = options || {};
    var screen = options.kind === 'screens', custom = !screen && options.custom === true;
    var artwork = screen ? plant('screens', false, 28, 18, 1) : plant('pleached', custom, custom ? 10 : 31, 10, 1);
    return '<svg viewBox="' + (screen ? '0 0 640 820' : '0 0 230 330') + '" aria-hidden="true" focusable="false" data-original-icon="' + (screen ? 'screens' : 'pleached') + '" data-custom-icon="' + custom + '">' + artwork + '</svg>';
  }
  function row(options) {
    options = options || {};
    var total = finite(options.count, 5);
    if (total <= 0) return '';
    var count = Math.min(5, Math.max(1, Math.floor(total)));
    var screen = options.kind === 'screens', custom = !screen && options.custom === true;
    var scale = screen ? 110 / 584 : 94 / 168;
    var step = screen ? 110 : (custom ? 210 : 168) * scale;
    var left = (600 - count * step) / 2, top = 47;
    var base = top + (screen ? 782 : 310) * scale;
    var body = [], i;
    for (i = 0; i < count; i += 1) {
      body.push('<g data-tree="' + (i + 1) + '">' + plant(screen ? 'screens' : 'pleached', custom, left + i * step, top, scale) + '</g>');
    }
    body.push('<path d="M' + n(left) + ' ' + n(base + 1) + 'H' + n(left + count * step) + '" stroke="#cbd8bb" stroke-width="1.4"/>');
    if (options.frameLabel) {
      var middle = left + (Math.floor(count / 2) + .5) * step;
      body.push(arrow(middle - step / 2, middle + step / 2, 32));
      body.push('<text x="' + n(middle) + '" y="18" text-anchor="middle" fill="#496a2d" font-size="16" font-family="inherit">' + escape(options.frameLabel) + '</text>');
    }
    if (count > 1 && options.spacingLabel) {
      var first = Math.floor((count - 2) / 2), x1 = left + (first + .5) * step, x2 = x1 + step;
      body.push('<path d="M' + n(x1) + ' ' + n(base + 6) + 'V253M' + n(x2) + ' ' + n(base + 6) + 'V253" stroke="#7c613e" stroke-width="1" stroke-dasharray="3 3"/>');
      body.push(arrow(x1, x2, 245));
      body.push('<text x="' + n((x1 + x2) / 2) + '" y="280" text-anchor="middle" fill="#496a2d" font-size="20" font-weight="700" font-family="inherit">' + escape(options.spacingLabel) + '</text>');
    }
    return '<svg viewBox="0 0 600 298" role="img" focusable="false" aria-label="' + escape(options.spacingLabel || options.frameLabel || '') + '" data-original-icon="' + (screen ? 'screens' : 'pleached') + '" data-preview-count="' + count + '" data-spacing-centres="' + n(finite(options.centresCm, 120)) + '">' + body.join('') + '</svg>';
  }
  return Object.freeze({ icon: icon, row: row });
});
